export class GetDataDTO<T> {
    constructor() {
        this.totalRows = 0;
        this.data = [];
    }

    totalRows: number;
    data: T[];
}
